import { computed, inject, provide, type ComputedRef, type InjectionKey } from "vue";

// Shared key so a nested affordance can tell an ancestor Tooltip is already showing a panel.
const activeTooltipKey: InjectionKey<ComputedRef<boolean>> = Symbol("activeTooltip");

// Called by Tooltip with its own state ORed into whatever it inherited.
export function provideTooltipActive(active: ComputedRef<boolean>): void {
  provide(activeTooltipKey, active);
}

// True when some ancestor Tooltip will render a panel on this hover.
export function useInsideActiveTooltip(): ComputedRef<boolean> {
  const outer = inject(activeTooltipKey, null);
  return computed(() => outer?.value === true);
}
